module.exports = __webpack_public_path__ + "img/uncheck-icon.76933161.svg";